import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { post } from '@/lib/api-client';
import { Card, ErrorNote, Field, SubmitButton } from '@/components/Form';

/** [FR-M01.8] Account recovery through a verified channel. */
export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await post<unknown>('/auth/password/forgot', { identifier }, { auth: false });
      const query = new URLSearchParams({ identifier });
      navigate(`/reset-password?${query.toString()}`);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Could not start the reset');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card title="Reset your password" subtitle="We will send a code to your email or mobile">
        <ErrorNote message={error} />
        <Field
          label="Email or mobile"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          required
        />
        <SubmitButton busy={busy}>Send reset code</SubmitButton>
        <Link to="/login" className="block text-sm text-slate-500 hover:underline">
          Back to sign in
        </Link>
      </Card>
    </form>
  );
}
